import {Component, computed, inject} from '@angular/core';
import {OverlayModule} from '@angular/cdk/overlay';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {EpgUserMenuNavigationComponent} from '@epg-apps/epg-user-menu-navigation';
import {EpgUserProfileInfoComponent} from '@epg-apps/epg-user-profile-info';
import {EpgUserMenuSelectionComponent} from '@epg-apps/epg-user-menu-selection';
import {EpgUserMenuNavigationFullscreenComponent} from '@epg-apps/epg-user-menu-navigation-fullscreen';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {
  EpgDownloadCenterService,
  EpgDownloadService,
} from '@epg-apps/epg-download';
import {ProfileService} from '@epg-apps/profile-api';
import {EpgIconButtonComponent} from '@epg-apps/ui-icon-button';

@Component({
  standalone: true,
  selector: 'epg-toolbar',
  imports: [
    OverlayModule,
    CdkAccordionModule,
    EpgUserMenuNavigationComponent,
    EpgUserProfileInfoComponent,
    EpgUserMenuSelectionComponent,
    EpgUserMenuNavigationFullscreenComponent,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    EpgIconButtonComponent,
  ],
  templateUrl: './epg-toolbar.component.html',
  styleUrl: './epg-toolbar.component.scss',
})
export class EpgToolbarComponent {
  isOpenSmallOverlay = false;
  isOpen = false;
  private downloadService = inject(EpgDownloadService);
  private downloadCenterService = inject(EpgDownloadCenterService);
  public isDownloading = computed(
    () => this.downloadCenterService.downloadState().downloading,
  );
  private readonly profileService = inject(ProfileService);
  userProfile = computed(() => this.profileService.userProfile());

  toggleOverlay($event: boolean) {
    this.isOpen = $event;
  }

  toggleOverlayBackdrop($event: boolean) {
    this.isOpenSmallOverlay = $event;
  }

  onDownload() {
    this.downloadService.download();
  }
}
